// Copyright (c) Bentley Systems
export enum FieldType {
  text,
  dropDown,
  checkBox,
  colorPicker,
}
